module.exports = __webpack_public_path__ + "fonts/OpenSans-Italic.ee80d3d5.woff2";